import SvgControlefault from '../../lib/jin/svgchartlib/09_Projects/TCO/07_Construction/BlockDivision/includes/primitives/Data'

export default SvgControlefault